import React from 'react';
import { IIconProps } from './utils';

export const Sparkle = ({
  fill = 'currentColor',
  height = 8,
  width = 8,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 8 8"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M1.875 0.416667C1.875 0.186548 1.68845 0 1.45833 0C1.22821 0 1.04167 0.186548 1.04167 0.416667V1.04167H0.416667C0.186548 1.04167 0 1.22821 0 1.45833C0 1.68845 0.186548 1.875 0.416667 1.875H1.04167V2.5C1.04167 2.73012 1.22821 2.91667 1.45833 2.91667C1.68845 2.91667 1.875 2.73012 1.875 2.5V1.875H2.5C2.73012 1.875 2.91667 1.68845 2.91667 1.45833C2.91667 1.22821 2.73012 1.04167 2.5 1.04167H1.875V0.416667Z"
      fill={fill}
    />
    <path
      d="M4.33747 0.950644C4.27732 0.79423 4.05602 0.79423 3.99586 0.950644L3.17916 3.07405C3.16057 3.12238 3.12238 3.16057 3.07405 3.17916L0.950644 3.99586C0.79423 4.05602 0.79423 4.27732 0.950644 4.33747L3.07405 5.15417C3.12238 5.17276 3.16057 5.21095 3.17916 5.25928L3.99586 7.38269C4.05602 7.5391 4.27732 7.5391 4.33747 7.38269L5.15417 5.25928C5.17276 5.21095 5.21095 5.17276 5.25928 5.15417L7.38269 4.33747C7.5391 4.27732 7.5391 4.05602 7.38269 3.99586L5.25928 3.17916C5.21095 3.16057 5.17276 3.12238 5.15417 3.07405L4.33747 0.950644Z"
      fill={fill}
    />
  </svg>
);
